module.exports = __webpack_public_path__ + "static/list-cover-blank-e8bb6dc5879b0240480aa073f8e263d6.jpg";